import $shared from '@/shared'
import Parse from 'parse'
import Vue from 'vue'

import {
    UserVM,
} from '@/models/user'
import {EmployerVM} from '@/models/employer'
import {ApplicantVM} from '@/models/applicant'

function load_user() {
    var promise = new Parse.Promise();
    var user = Parse.User.current();
    if (
        user &&
        $shared.user.type != null &&
        $shared.user.profile != null
    ) {
        /*
        var route = ($shared.user.type == 'Employer') ? 'employer-with-id' : 'applicant-with-id';
        next({name: route, params: {id: $shared.user.profile}});
        */
        promise.resolve($shared.user);
    } else if (user) {
        let loader = Vue.$loading.show()
        var query = new Parse.Query(Parse.User);
        query.equalTo('objectId', user.id);
        query.include('applicant');
        query.include('employer');
        $shared.user.vm = UserVM(user);
        query.first().then((result) => {
            var applicant = result.get('applicant'),
                employer = result.get('employer');

            if (applicant) {
                $shared.user.type = applicant.className;
                $shared.user.profile = ApplicantVM(applicant);
            } else if (employer) {
                $shared.user.type = employer.className;
                $shared.user.profile = EmployerVM(employer);
                $shared.admin = employer.get("admin") == true;
            } else {
                //next({name: 'login'});
                promise.reject();
                return;
            }
            var route = ($shared.user.type == 'Employer') ? 'employer-with-id' : 'applicant-with-id';
            //next({name: route, params: {id: $shared.user.profile}});
            promise.resolve($shared.user);
        }).catch((err) => {
            // TODO: error handling
            console.log(err);
            //next({name: 'login'});
            promise.reject(err);
        }).always(() => {
            loader.hide();
        });
    } else {
        //next({name: 'login'});
        promise.reject();
    }
    return promise;
}


export default load_user




// WEBPACK FOOTER //
// ./src/utils/load-user.js